import {
  colors, fonts, fontSizes, measurements, BREAKPOINTS
} from 'theme'
import css from 'styled-jsx/css'

export const header = css`
  header {
    display: flex;
    justify-content: flex-end;
    background-color: ${colors.frame};
    height: ${measurements.headerHeight};
    z-index: 100;
    position: relative;
    width: 100%;
  }
  @media screen and (max-width: ${BREAKPOINTS.LG}) {
    header {
      position: fixed;
    }
  }

  .menus {
    display: flex;
    list-style: none;
    padding: 0;
  }
  ul {
    padding: 0;
    margin: 0;
  }

  li {
    color: ${colors.white};
    font-size: ${fontSizes.small};
    align-items: center;
    display: flex;
    margin-right: 1rem;
    padding: 0 1rem;
    position: relative;
    cursor: pointer;
    position: relative;
    list-style: none;
  }

  li :global(i) {
    margin-right: 1rem;
  }

  li:last-child :global(i) {
    margin-right: 0;
    margin-left: 1rem;
  }

  .user-initials {
    background-color: ${colors.primary};
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  li:hover,
  li.active {
    cursor: pointer;
    background-color: ${colors.footerBg};
  }
  li:hover ul {
    visibility: visible;
  }
  li ul {
    position: absolute;
    top: 70px;
    background-color: ${colors.white};
    right: 0;
    padding: 0;
    visibility: hidden;
    border: solid 1px ${colors.border};
    border-radius: 0.25rem;
    width: 12rem;
  }
  li ul li {
    margin: 0;
    color: ${colors.footerBg};
    padding: 0.5rem 1rem;
  }
  li ul li :global(*) {
    color: ${colors.footerBg};
  }

  li ul li:hover,
  li ul li:hover :global(*) {
    color: ${colors.white};
  }

  li ul li span {
    padding: 0 1rem;
    width: 7.5rem;
  }

  .showOnMobile {
    display: none;
  }
  
  @media screen and (max-width: ${BREAKPOINTS.LG}) {
    .hideOnMobile {
      display: none;
    }

    .showOnMobile {
      display: block;
    }
  }
`

export const content = css`
  .container {
    display: flex;
    width: 100%;
  }

  .content {
    flex: 1;
    background: ${colors.lightGray};
    transition: width 0.3s ease;
  }

  .container.hide-lateral-menu .content {
    width: 100%;
  }

  @media screen and (max-width: ${BREAKPOINTS.LG}) {
    .content {
      width: 100%;
    }
  }
`

export const title = css`
  .title {
    background-color: ${colors.frame};
    display: flex;
    color: ${colors.text};
    width: 100%;
    max-height: 5rem;
    padding: 1.25rem 1rem;
    background-color: ${colors.white};
    border: solid 1px ${colors.border};
    justify-content: flex-start;
    align-items: center;
  }
  @media screen and (max-width: ${BREAKPOINTS.LG}) {
    .title {
      margin-top: 4.375rem;
    }
  }
`

export const paymentRemainder = css`
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: ${colors.warning};
    color: ${colors.white};
    margin: 1rem;
    padding: 1rem 3rem;
  }
  .container h4 {
    color: ${colors.white};
  }
  .container h4,
  .container p {
    margin: 0;
  }
  .container :global(.icon-warning) {
    position: absolute;
    top: 50%;
    left: 1rem;
  }
  .container :global(.icon-close) {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
  }
`

export const teamAssistantInfoRemainderStyles = css`
  .tooltip-content {
    text-align: center;
    color: ${colors.white};
    padding-bottom: 0.5rem;
  }
  .tooltip-content .title {
    color: ${colors.white};
    margin: 0.5rem 0;
  }
  .close-icon {
    position: absolute;
    top: 2.5rem;
    right: 0.5rem;
    cursor: pointer;
  }
`
